export default __webpack_public_path__ + "static/media/uk.70e4e37f.svg";